// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1cI6i","imageUploader":"EGiftCard_imageUploader__U6s-l"};